import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GraduationCap, ShieldCheck, ArrowRight } from 'lucide-react';

// Integrated Global Brand Header
import COEHeader from './COEHeader';

const StudentPromotionManager = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, tenant, orgInfo } = location.state || {};

  const resolvedUser = user || JSON.parse(localStorage.getItem('user') || '{}');
  const resolvedTenant = tenant || {
    id: localStorage.getItem('tenantId') || '',
    name: localStorage.getItem('tenantName') || '',
    subdomain: localStorage.getItem('tenantSubdomain') || ''
  };
  const resolvedOrgInfo = orgInfo || JSON.parse(localStorage.getItem('orgInfo') || '{}');

  const handleNavigate = (cardKey) => {
    const routingState = {
      state: {
        user: resolvedUser,
        tenant: resolvedTenant,
        orgInfo: resolvedOrgInfo,
        source: 'student-promotion-hub'
      }
    };

    if (cardKey === 'promote-students') {
      navigate('/coe/promote-students', routingState);
    } else if (cardKey === 'promotion-policies') {
      navigate('/coe/promotion-policies', routingState);
    } else {
      navigate('/coe', routingState);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 antialiased font-sans">
      <COEHeader orgInfo={resolvedOrgInfo} tenant={resolvedTenant} />

      <main className="mx-auto max-w-5xl px-6 py-12">
        {/* Dynamic Interactive Workflow Grid */}
        <div className="grid gap-6 md:grid-cols-2">
          
          {/* Card 1: Main Action Core */}
          <div
            onClick={() => handleNavigate('promote-students')}
            className="group relative flex flex-col justify-between rounded-2xl border border-emerald-200/80 bg-white p-6 shadow-sm transition-all duration-300 cursor-pointer hover:shadow-md hover:border-emerald-400 ring-offset-2 hover:ring-2 hover:ring-emerald-500/10"
          >
            <div>
              <div className="flex items-center justify-between">
                <div className="rounded-xl p-3 bg-emerald-50 text-emerald-600 border border-emerald-100 transition-transform group-hover:scale-105">
                  <GraduationCap className="h-6 w-6" />
                </div>
                <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded bg-emerald-100 text-emerald-800">
                  Primary Task
                </span>
              </div>

              <div className="mt-5">
                <h3 className="text-lg font-bold text-slate-900 group-hover:text-emerald-700 transition-colors">
                  Advance Cohorts & Grade Levels
                </h3>
                <p className="mt-2 text-xs text-slate-500 leading-relaxed">
                  Promote classes, manage criteria exceptions, and process student graduations for the new year.
                </p>
              </div>
            </div>

            <div className="mt-6">
              <button
                type="button"
                className="w-full rounded-xl py-2.5 px-4 text-center text-sm font-semibold text-white bg-emerald-600 hover:bg-emerald-700 transition-all flex items-center justify-center gap-2"
              >
                <span>Start Promotion Wizard</span>
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </button>
            </div>
          </div>

          {/* Card 2: Configuration Core */}
          <div
            onClick={() => handleNavigate('promotion-policies')}
            className="group relative flex flex-col justify-between rounded-2xl border border-blue-200/80 bg-white p-6 shadow-sm transition-all duration-300 cursor-pointer hover:shadow-md hover:border-blue-400 ring-offset-2 hover:ring-2 hover:ring-blue-500/10"
          >
            <div>
              <div className="flex items-center justify-between">
                <div className="rounded-xl p-3 bg-blue-50 text-blue-600 border border-blue-100 transition-transform group-hover:scale-105">
                  <ShieldCheck className="h-6 w-6" />
                </div>
                <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded bg-blue-100 text-blue-800">
                  Setup Panel
                </span>
              </div>

              <div className="mt-5">
                <h3 className="text-lg font-bold text-slate-900 group-hover:text-blue-700 transition-colors">
                  Institutional Policy Rulesets
                </h3>
                <p className="mt-2 text-xs text-slate-500 leading-relaxed">
                  Configure passing benchmarks, attendance limits, exemptions, and grading metrics.
                </p>
              </div>
            </div>

            <div className="mt-6">
              <button
                type="button"
                className="w-full rounded-xl py-2.5 px-4 text-center text-sm font-semibold text-white bg-slate-800 hover:bg-slate-900 transition-all flex items-center justify-center gap-2"
              >
                <span>Manage Rule Parameters</span>
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </button>
            </div>
          </div>

        </div>
      </main>

      {/* Simplified Clear Footer */}
      <footer className="mt-20 border-t border-slate-200 bg-white py-6 text-center text-xs font-medium text-slate-400">
        Campus Information System • Student Lifecycle Engine v2.5
      </footer>
    </div>
  );
};

export default StudentPromotionManager;